import React, { ChangeEvent } from 'react';

interface sliderInterface {
  min_value: number;
  max_value: number;
  step_value: number;
  input_value: number;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const RangeSlider = ({
  min_value,
  max_value,
  step_value,
  input_value,
  className,
  handleChange,
}: sliderInterface): JSX.Element => {
  const sliderRange =
    ((Number(input_value) - min_value) / (max_value - min_value)) * 100;
  return (
    <div className={`relative slider-container ${className}`}>
      <div className="track" style={{ width: `${sliderRange}%` }} />
      <input
        id="slider"
        type="range"
        className="slider"
        onChange={handleChange}
        min={min_value}
        max={max_value}
        value={input_value}
        step={step_value}
      />
    </div>
  );
};

export { RangeSlider };
